import successNotification from "./success-notification";

export default successNotification;